<main class="admin-access-denied" role="main" aria-label="Admin access denied">
  <div class="admin-access-denied__card">
    <h1 class="admin-access-denied__title">Admin access required</h1>
    <p class="admin-access-denied__message" role="alert">{{ message }}</p>
    <p class="admin-access-denied__hint">
      Survey administration is restricted to signed-in administrators. You cannot view or change surveys from this area without signing in.
    </p>
    <a class="btn btn-primary" routerLink="/intake/create">Go to survey</a>
  </div>
</main>
